// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as CalcRouteImport } from './routes/calc'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RecipesIndexRouteImport } from './routes/recipes/index'
import { Route as LearnIndexRouteImport } from './routes/learn/index'
import { Route as IngredientsIndexRouteImport } from './routes/ingredients/index'
import { Route as DiscoverIndexRouteImport } from './routes/discover/index'
import { Route as ChangelogIndexRouteImport } from './routes/changelog/index'
import { Route as RecipesNewRouteImport } from './routes/recipes/new'
import { Route as LearnWhyUseAnIceCreamCalculatorRouteImport } from './routes/learn/why-use-an-ice-cream-calculator'
import { Route as LearnWhichIngredientsDoINeedToMakeGreatIceCreamRouteImport } from './routes/learn/which-ingredients-do-i-need-to-make-great-ice-cream'
import { Route as LearnHowToFixHardIceCreamRouteImport } from './routes/learn/how-to-fix-hard-ice-cream'
import { Route as LearnFpdfRouteImport } from './routes/learn/fpdf'
import { Route as LearnFaqRouteImport } from './routes/learn/faq'
import { Route as IngredientsSearchRouteImport } from './routes/ingredients/search'
import { Route as IngredientsSlugRouteImport } from './routes/ingredients/$slug'
import { Route as DiscoverSearchRouteImport } from './routes/discover/search'
import { Route as ChangelogSlugRouteImport } from './routes/changelog/$slug'
import { Route as UsersUserIdIndexRouteImport } from './routes/users/$userId/index'
import { Route as RecipesSlugIndexRouteImport } from './routes/recipes/$slug/index'
import { Route as DevComponentsIndexRouteImport } from './routes/dev/components/index'
import { Route as RecipesSlugEditRouteImport } from './routes/recipes/$slug/edit'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const CalcRoute = CalcRouteImport.update({
            id: '/calc',path: '/calc',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const RecipesIndexRoute = RecipesIndexRouteImport.update({
            id: '/recipes/',path: '/recipes/',getParentRoute: () => rootRouteImport
          })
const LearnIndexRoute = LearnIndexRouteImport.update({
            id: '/learn/',path: '/learn/',getParentRoute: () => rootRouteImport
          })
const IngredientsIndexRoute = IngredientsIndexRouteImport.update({
            id: '/ingredients/',path: '/ingredients/',getParentRoute: () => rootRouteImport
          })
const DiscoverIndexRoute = DiscoverIndexRouteImport.update({
            id: '/discover/',path: '/discover/',getParentRoute: () => rootRouteImport
          })
const ChangelogIndexRoute = ChangelogIndexRouteImport.update({
            id: '/changelog/',path: '/changelog/',getParentRoute: () => rootRouteImport
          })
const RecipesNewRoute = RecipesNewRouteImport.update({
            id: '/recipes/new',path: '/recipes/new',getParentRoute: () => rootRouteImport
          })
const LearnWhyUseAnIceCreamCalculatorRoute = LearnWhyUseAnIceCreamCalculatorRouteImport.update({
            id: '/learn/why-use-an-ice-cream-calculator',path: '/learn/why-use-an-ice-cream-calculator',getParentRoute: () => rootRouteImport
          })
const LearnWhichIngredientsDoINeedToMakeGreatIceCreamRoute = LearnWhichIngredientsDoINeedToMakeGreatIceCreamRouteImport.update({
            id: '/learn/which-ingredients-do-i-need-to-make-great-ice-cream',path: '/learn/which-ingredients-do-i-need-to-make-great-ice-cream',getParentRoute: () => rootRouteImport
          })
const LearnHowToFixHardIceCreamRoute = LearnHowToFixHardIceCreamRouteImport.update({
            id: '/learn/how-to-fix-hard-ice-cream',path: '/learn/how-to-fix-hard-ice-cream',getParentRoute: () => rootRouteImport
          })
const LearnFpdfRoute = LearnFpdfRouteImport.update({
            id: '/learn/fpdf',path: '/learn/fpdf',getParentRoute: () => rootRouteImport
          })
const LearnFaqRoute = LearnFaqRouteImport.update({
            id: '/learn/faq',path: '/learn/faq',getParentRoute: () => rootRouteImport
          })
const IngredientsSearchRoute = IngredientsSearchRouteImport.update({
            id: '/ingredients/search',path: '/ingredients/search',getParentRoute: () => rootRouteImport
          })
const IngredientsSlugRoute = IngredientsSlugRouteImport.update({
            id: '/ingredients/$slug',path: '/ingredients/$slug',getParentRoute: () => rootRouteImport
          })
const DiscoverSearchRoute = DiscoverSearchRouteImport.update({
            id: '/discover/search',path: '/discover/search',getParentRoute: () => rootRouteImport
          })
const ChangelogSlugRoute = ChangelogSlugRouteImport.update({
            id: '/changelog/$slug',path: '/changelog/$slug',getParentRoute: () => rootRouteImport
          })
const UsersUserIdIndexRoute = UsersUserIdIndexRouteImport.update({
            id: '/users/$userId/',path: '/users/$userId/',getParentRoute: () => rootRouteImport
          })
const RecipesSlugIndexRoute = RecipesSlugIndexRouteImport.update({
            id: '/recipes/$slug/',path: '/recipes/$slug/',getParentRoute: () => rootRouteImport
          })
const DevComponentsIndexRoute = DevComponentsIndexRouteImport.update({
            id: '/dev/components/',path: '/dev/components/',getParentRoute: () => rootRouteImport
          })
const RecipesSlugEditRoute = RecipesSlugEditRouteImport.update({
            id: '/recipes/$slug/edit',path: '/recipes/$slug/edit',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRoute: AccountRoute,CalcRoute: CalcRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,TermsRoute: TermsRoute,ChangelogSlugRoute: ChangelogSlugRoute,DiscoverSearchRoute: DiscoverSearchRoute,IngredientsSlugRoute: IngredientsSlugRoute,IngredientsSearchRoute: IngredientsSearchRoute,LearnFaqRoute: LearnFaqRoute,LearnFpdfRoute: LearnFpdfRoute,LearnHowToFixHardIceCreamRoute: LearnHowToFixHardIceCreamRoute,LearnWhichIngredientsDoINeedToMakeGreatIceCreamRoute: LearnWhichIngredientsDoINeedToMakeGreatIceCreamRoute,LearnWhyUseAnIceCreamCalculatorRoute: LearnWhyUseAnIceCreamCalculatorRoute,RecipesNewRoute: RecipesNewRoute,ChangelogIndexRoute: ChangelogIndexRoute,DiscoverIndexRoute: DiscoverIndexRoute,IngredientsIndexRoute: IngredientsIndexRoute,LearnIndexRoute: LearnIndexRoute,RecipesIndexRoute: RecipesIndexRoute,RecipesSlugEditRoute: RecipesSlugEditRoute,DevComponentsIndexRoute: DevComponentsIndexRoute,RecipesSlugIndexRoute: RecipesSlugIndexRoute,UsersUserIdIndexRoute: UsersUserIdIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)